import React from 'react';
import '../../App.css';
import HeroS from '../hsection';
import MembershipForm from '../form';

function SignUp() {
return (
    <>
    <HeroS />
    <MembershipForm />
    </>
);
}

export default SignUp;